<template>
  <human-nav current="fafact">
    <template #mainContent>
      <trk-show file-name="whole_5000.vtk" container-id="fatrk"></trk-show>
    </template>
  </human-nav>
</template>

<script>
import TrkShow from "@/components/xtk/trkShow";
import HumanNav from "@/components/public/humanNav";
export default {
  name: "faFact",
  components: {HumanNav, TrkShow}
}
</script>

<style scoped>

</style>